
<div class="gradient_teble_wrapper">
	<span i18n="@@dashboard.top_customers">Top Customers</span>
	<table class="top_table">
		<thead>
			<tr>
				<th style="width: 1%;">№</th>
				<th i18n="@@dashboard.name">Name</th>
				<th i18n="@@dashboard.email">Email</th>
				<th i18n="@@dashboard.total_earnings">Total Earnings</th>
			</tr>
		</thead>
		<tbody *ngIf="users.length > 0; else noCustomers">
			<tr *ngFor="let user of users; let i = index">
				<td class="number">{{ i + 1 }}</td>
				<td>{{ user.client }}</td>
				<td>{{ user.email }}</td>
				<td [innerHtml]="user.amount" style="white-space: nowrap;"></td>
			</tr>
		</tbody>
	</table>

	<ng-template #noCustomers>
		<tbody>
			<tr>
				<td colspan="4" style="text-align: center; padding: 10px;" i18n="@@dashboard.no_customer_found">No customers found.</td>
			</tr>
		</tbody>
	</ng-template>

</div>
